export const formMessages = {
    required: () => 'Required',
    email: () => 'Email is incorrect',
    url: () => 'Url is incorrect',
    urlBulkValidation: () => 'List contains invalid urls'
}
